"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultTo = require("lodash/defaultTo");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var asRendition_1 = require("../asRendition");
var Base = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: ", ";\n\tright: ", ";\n\tbottom: ", ";\n\tleft: ", ";\n\tz-index: ", ";\n\tbackground: ", ";\n"], ["\n\tposition: fixed;\n\ttop: ", ";\n\tright: ", ";\n\tbottom: ", ";\n\tleft: ", ";\n\tz-index: ", ";\n\tbackground: ", ";\n"])), function (props) { return defaultTo(props.top, 'auto'); }, function (props) { return defaultTo(props.right, 'auto'); }, function (props) { return defaultTo(props.bottom, 'auto'); }, function (props) { return defaultTo(props.left, 'auto'); }, function (props) { return defaultTo(props.z, 0); }, function (props) { return defaultTo(props.bg, 'none'); });
var dimensions = recompose_1.withProps(function (props) {
    return {
        top: props.top === true ? 0 : props.top,
        right: props.right === true ? 0 : props.right,
        bottom: props.bottom === true ? 0 : props.bottom,
        left: props.left === true ? 0 : props.left,
    };
});
exports.default = recompose_1.compose(styled_components_1.withTheme, dimensions, asRendition_1.default)(Base);
var templateObject_1;
